export const LINK_BUTTON = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.LinkButtonElement';
